import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IRegisterReducer } from 'core/slices/register';

const actionId = (state: RootState, id?: number) => id || state.state[EntityTypes.ACTION];
const sessionAttemptId = (state: RootState) => state.state[EntityTypes.SESSION_ATTEMPT];
const register = (state: RootState) => state.register;

export const selectActionRegister = createSelector(
  [actionId, sessionAttemptId, register],
  (actionId: number, sessionAttemptId: number, register: IRegisterReducer) => {
    if (!actionId) return null;

    //Can't remember why I did this. .actionRegisterId is null
    // const id = actionId === feed.feed[feed.index]?.actionId ? feed.feed[feed.index].actionRegisterId : actionId;
    if (!register.attempts[sessionAttemptId] || !register.attempts[sessionAttemptId].actions) return null;
    return register.attempts[sessionAttemptId].actions[actionId];
  },
);
